import * as React from 'react'
import withSizes from 'react-sizes'

import P5Wrapper from './P5Wrapper'
import Prompt from './Prompt'
import * as Styles from './styles'

interface Props {
  height: number
  width: number
  prompt?: any

  getSketch(width: number, height: number): any
}

interface State {
  sketch?: any
}

class Sketch extends React.Component<Props, State> {
  state: State = {}

  componentDidMount() {
    this.setState({ sketch: this.props.getSketch(this.props.width, this.props.height) })
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.getSketch !== this.props.getSketch) {
      this.setState({ sketch: this.props.getSketch(this.props.width, this.props.height) })
    }
  }

  render() {
    return (
      <Styles.Frame>
        {this.state.sketch && <P5Wrapper sketch={this.state.sketch} />}
        {this.props.prompt && <Prompt>{this.props.prompt}</Prompt>}
      </Styles.Frame>
    )
  }
}

export default withSizes((f: any) => f)(Sketch)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Sketch.tsx